import React, { useMemo, useState, useCallback } from 'react'
import {
  Text, IcoMoon, QuestionIcon, ArrowDownIcon,
} from '@usap/uicomponents'
import { commaSeparetedValue, outsideClickHandler } from '@usap/core'
import Style from './style/Subtotal.css'
import constantStyle from './style/constant'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'
import SubtotalWmo from './SubtotalWmo'

const SubTotal = props => {
  const { data } = props
  const [showToolTip, setShowToolTip] = useState(false)

  const toolTipText = '<b>Subtotal</b> is the sum of all item totals. Each item total is comprised of <b>Unit Price</b>, multiplied by <b>Quantity</b>.'

  const onToolTipClick = useCallback(
    event => {
      event.stopPropagation()
      outsideClickHandler(
        showToolTip,
        ['subtotaltooltipicon'],
        () => {
          setShowToolTip(false)
        },
      )
      setShowToolTip(!showToolTip)
    },
    [showToolTip, setShowToolTip],
  )

  const textMessage = useMemo(
    () => ({
      __html: toolTipText,
    }),
    [toolTipText],
  )

  const isWmoEnabled = useWmoEnabled()
  const subTotal = data.estSubTotal ? parseFloat(data.estSubTotal) : parseFloat(data.subTotal)

  if (isWmoEnabled) {
    return (
      <SubtotalWmo
        data={data}
        showToolTip={showToolTip}
        onToolTipClick={onToolTipClick}
        textMessage={textMessage}
      />
    )
  }

  return (
    <Style.Container direction="row" justify="between">
      {showToolTip && (
      <Style.TooltipContainer
        id="tooltiptext"
        align="center"
        justify="center"
        height="102px"
        border={constantStyle.tooltipBorder}
        background="white"
      >
        <Style.TooltipText
          dangerouslySetInnerHTML={textMessage}
        />
        <Style.TooltipPointer>
          <IcoMoon icon={ArrowDownIcon} color="white" size="40px" />
        </Style.TooltipPointer>
      </Style.TooltipContainer>
      )}

      <Text size="small">
        Subtotal:
      </Text>

      <Style.InfoIcon id="subtotaltooltipicon">
        <IcoMoon
          icon={QuestionIcon}
          size="18px"
          color="#b2b2b2"
          onClick={onToolTipClick}
        />
      </Style.InfoIcon>

      <Text size="small" color="dark-2">
        $
        {commaSeparetedValue(subTotal)}
      </Text>
    </Style.Container>
  )
}

export default SubTotal
